module.exports = __webpack_public_path__ + "static/media/Wings-NoTag.927367ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Wings-NoTag.svg
// module id = 364
// module chunks = 0